const TDVAdList = [
  "anhpv@weatherplus.vn",
  "khanhnt@weatherplus.vn",
  "lannh@weatherplus.vn",
  "luyennt@weatherplus.vn",
  "loannth@weatherplus.vn",
  "thaodp@weatherplus.vn",
  "vanptc@weatherplus.vn",
  "tudtc@weatherplus.vn"
];
export function checkIsTDVAd(email) {
  return TDVAdList.includes(email);
}
